import {Button as ActionButton} from 'antd'
import '../../../common.scss'
const Button = ({ buttonText, className, onClick, type, htmlType,isDisable }) => {
    return <ActionButton
        className={`${className} ${buttonText === "Submit" ? 'buttonSubmit' : buttonText === 'Cancel' ? 'buttonCancel' : buttonText === 'Search' || 'clear' ? "buttonSubmit" : ''}`}
        onClick={onClick}
        size='middle'
        type={type}
        htmlType={htmlType}
        disabled={isDisable? isDisable : false}
    >
        {buttonText}
    </ActionButton>
}
export default Button